import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FormDatePickerWrapper,
  FormInputWrapper
} from "components/common/Form/Form.style";
import React, { FocusEvent, FunctionComponent, SyntheticEvent } from "react";
import ReactDatePicker from "react-datepicker";
import { ResetButton } from "screens/Onboarding/SignUp/CustomerPersonalInfo/CustomerPersonalInfoForm.style";

interface IProps {
  onInputClick: () => void;
  onChange: (date: Date, event?: React.SyntheticEvent<any>) => void;
  selected: Date | null;
  onFocus: () => void;
  onClearButtonFocus: () => void;
  onClearButtonClick: () => void;
}

export const testIds = {
  textInput: "date-form-text-input"
};

const FormDatePicker: FunctionComponent<IProps> = ({
  onChange,
  onInputClick,
  selected,
  onFocus,
  onClearButtonFocus,
  onClearButtonClick
}: IProps) => {
  const handleOnChange = (date: Date, event?: SyntheticEvent<any>) => {
    if (event) {
      event.preventDefault();
    }
    onChange(date);
  };

  const handleOnClearButtonClick = (
    event: SyntheticEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    onClearButtonClick();
  };

  const handleOnFocus = (event: FocusEvent<HTMLInputElement>) => {
    event.target.readOnly = true;
    onFocus();
  };

  const handleOnClearButtonFocus = (event: FocusEvent<HTMLButtonElement>) => {
    onClearButtonFocus();
  };

  const onChangeRaw = (event: SyntheticEvent<any>) => {
    event.preventDefault();
  };

  return (
    <FormDatePickerWrapper>
      <ReactDatePicker
        onInputClick={onInputClick}
        name="birthday"
        onChange={handleOnChange}
        onYearChange={handleOnChange}
        onMonthChange={handleOnChange}
        onChangeRaw={onChangeRaw}
        selected={selected}
        onFocus={handleOnFocus}
        showMonthDropdown
        disabledKeyboardNavigation
        showYearDropdown
        maxDate={new Date()}
        dropdownMode="select"
        customInput={<FormInputWrapper data-testId={testIds.textInput} />}
      />
      <ResetButton
        name="birthday"
        onFocus={handleOnClearButtonFocus}
        onClick={handleOnClearButtonClick}
        type="hidden"
      >
        <FontAwesomeIcon icon="times" size="2x" />
      </ResetButton>
    </FormDatePickerWrapper>
  );
};

export default FormDatePicker;



// WEBPACK FOOTER //
// ./src/components/common/Form/FormDatePicker.tsx